module.exports = __webpack_public_path__ + "img/WeChat.8aadcbed.png";